import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
export var eventKey = 'core_collections-collection_tile-click';
/**
 * An event for when a collection tile click impression occurs.
 */ export function trackCoreCollectionsCollectionTileClick(contextToken_string, productBasedCollectionToken, requestId_string2, screenContext_string3, containerContext_string4, brandPromoToken_string5) {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false,
        parameters: {
            contextToken_string: contextToken_string,
            productBasedCollectionToken: productBasedCollectionToken,
            requestId_string2: requestId_string2,
            screenContext_string3: screenContext_string3,
            containerContext_string4: containerContext_string4,
            brandPromoToken_string5: brandPromoToken_string5
        }
    });
}
